import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PublicHeader = () => {
  useEffect(() => {
    // Load external stylesheets - exactly like FinalLandingPage
    const loadCSS = (href, media = 'all') => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      link.media = media
      document.head.appendChild(link)
      return link
    }

    // Load external scripts - exactly like FinalLandingPage
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    }

    // Load all CSS files - exactly like FinalLandingPage
    const links = [
      loadCSS('/css/screen_layout_mega.css'),
      loadCSS('/css/screen_layout_large.css', 'only screen and (min-width:801px) and (max-width:1366px)'),
      loadCSS('/css/screen_layout_medium.css', 'only screen and (min-width:701px) and (max-width:800px)'),
      loadCSS('/css/screen_layout_small.css', 'only screen and (min-width:50px) and (max-width:700px)'),
      loadCSS('/css/slimmenu.css'),
      loadCSS('/css/default.css'),
      loadCSS('/css/component.css'),
      loadCSS('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css'),
      loadCSS('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'),
      loadCSS('https://fonts.googleapis.com/css?family=Ubuntu:700'),
      loadCSS('https://fonts.googleapis.com/css?family=Varela+Round'),
      loadCSS('https://fonts.googleapis.com/css?family=Quicksand'),
      loadCSS('https://fonts.googleapis.com/css?family=Josefin+Sans|Slabo+27px|Ubuntu+Condensed|Yanone+Kaffeesatz'),
      loadCSS('https://fonts.googleapis.com/css?family=Raleway')
    ]

    // Load scripts and initialize - working version from ScoreKeepingPageV2
    const initScripts = async () => {
      try {
        await loadScript('/js/jquery.min.js')
        
        // Try to load easing, if fails use simple easing
        try {
          await loadScript('/js/jquery.easing.min.js')
        } catch (e) {
          console.log('Easing script not found, using simple easing')
          // Add simple easing function if script not found
          if (window.jQuery && !window.jQuery.easing.easeInOutQuint) {
            window.jQuery.easing.easeInOutQuint = function (x) {
              return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
            }
          }
        }
        
        await loadScript('/js/jquery.slimmenu.js')
        
        // Load Bootstrap JS for accordion and other components
        try {
          await loadScript('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js')
          console.log('✅ Bootstrap JS loaded')
        } catch (e) {
          console.log('Bootstrap JS not found, continuing without it')
        }
        
        // Try modernizr, but don't fail if not found
        try {
          await loadScript('/js/modernizr.custom.js')
        } catch (e) {
          console.log('Modernizr not found, continuing without it')
        }
        
        // Initialize menu - exactly like FinalLandingPage with same timeout
        setTimeout(() => {
          if (window.$ && window.$.fn.slimmenu) {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            })
            console.log('✅ PublicHeader Slimmenu initialized');
          }
        }, 1500) // Same timeout as FinalLandingPage
      } catch (error) {
        console.error('Error loading main scripts:', error)
        
        // Fallback - try to initialize menu anyway with basic settings
        setTimeout(() => {
          if (window.$ && window.$.fn.slimmenu) {
            try {
              window.$('ul.slimmenu').slimmenu({
                resizeWidth: '1100',
                collapserTitle: 'Main Menu',
                easingEffect: 'swing', // fallback easing
                animSpeed: 'medium',
                indentChildren: true,
                childrenIndenter: '&raquo;'
              })
              console.log('✅ PublicHeader Slimmenu initialized with fallback');
            } catch (e) {
              console.error('❌ Failed to initialize slimmenu:', e);
            }
          }
        }, 2000)
      }
    }

    initScripts()

    return () => {
      // Cleanup
      links.forEach(link => {
        if (link && link.parentNode) {
          link.parentNode.removeChild(link)
        }
      })
    }
  }, []);

  return (
    <>
      <header>
        <div id="zero">
          <img className="logo" src="/logo.png" alt="SportsTMS Logo" />
        </div>
        <div id="one">
          <div id="two">Sports Tournament Management System</div>
          <div id="three">THE OFFICIAL SITE OF INDIAN BASEBALL</div>
        </div>
        <img className="" src="/second_logo.png" alt="Secondary Logo" />
      </header>

      <nav>
        <ul className="slimmenu">
          <li><Link to="/"><span className="glyphicon glyphicon-home" style={{ fontSize: '15px' }}></span></Link></li>
          <li><a href="#">About</a>
            <ul>
              <li><Link to="/history">History</Link></li>
              <li><a href="/pdf/Amateur_Baseball_federation.zip">Constitution</a></li>
              <li><Link to="/international-recognition">International Recognition</Link></li>
              <li><Link to="/registration">Registration</Link></li>
              <li><Link to="/affiliates">Affiliates</Link></li>
              <li><Link to="/bearer">Executive Committee</Link></li>
            </ul>
          </li>
          <li><a href="#">Rules</a>
            <ul>
              <li><a href="#">Basics</a>
                <ul>
                  <li><Link to="/score-keeping">Keeping Score</Link></li>
                  <li><Link to="/baseball-lingo">Baseball Lingo</Link></li>
                  <li><Link to="/abbreviation">Abbreviation</Link></li>
                  <li><Link to="/stats">Stats 101</Link></li>
                </ul>
              </li>
              <li><Link to="/rules">Baseball Rules</Link></li>
              <li><a href="#">Play Baseball</a>
                <ul>
                  <li><Link to="/skills">4 Skills of Baseball</Link></li>
                  <li><Link to="/batting-order">Batting Order</Link></li>
                  <li><Link to="/fielding-position">Fielding Position</Link></li>
                  <li><Link to="/why-play">Why Play Baseball</Link></li>
                  <li><a href="/pdf/manual.pdf" target="_blank">Manual</a></li>
                </ul>
              </li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manual</a></li>
            </ul>
          </li>
          <li><Link to="/events">Events</Link></li>
          <li><a href="#">Schedule</a>
            <ul>
              <li><Link to="/forthcoming-events">Forthcoming Events</Link></li>
              <li><Link to="/calendar-events">Calendar Events</Link></li>
            </ul>
          </li>
          <li><a href="#">Participants</a>
            <ul>
              <li><Link to="/user-login">User Login</Link></li>
              <li><a href="#">Roster</a></li>
              <li><Link to="/certificate-verify">Certificates</Link></li>
            </ul>
          </li>
          <li><a href="#">Information</a>
            <ul>
              <li><Link to="/committees">Committees</Link></li>
              <li><Link to="/accounts">Accounts</Link></li>
              <li><Link to="/rti">RTI</Link></li>
              <li><Link to="/website-info">Website information</Link></li>
            </ul>
          </li>
          <li><a href="#">Downloads</a>
            <ul>
              <li><a href="/pdf/Roster_form.pdf" target="_blank">Roster form</a></li>
              <li><a href="/pdf/team_Roster.pdf" target="_blank">Team roster</a></li>
              <li><a href="/pdf/Score_Sheet.pdf" target="_blank">Score sheet</a></li>
            </ul>
          </li>
          <li><Link to="/photo-gallery">Gallery</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </nav>
    </>
  );
};

export default PublicHeader;
